export { default } from './omitEventHandlers';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/omitEventHandlers/index.js
// module id = 1757
// module chunks = 25